import styled from 'styled-components';
import { formLabel } from '../theme/typography/styles.js';
import { fontSize } from '../theme/typography/fontSize.js';
import { fontWeight } from '../theme/typography/fontWeight.js';
import { themeGet } from '../v2/foundation/theme/themeGet/get.js';
import { marginRight, unit } from '../v2/foundation/spacing/utils.js';

var PhoneInputContainer = styled.div.withConfig({
  displayName: "PhoneInputContainer",
  componentId: "sc-1pl3hac-0"
})(["display:", ";flex-direction:column;"], function (props) {
  return props.$stretch ? 'flex' : 'inline-flex';
});
var PhoneInputLabel = styled.label.withConfig({
  displayName: "PhoneInputLabel",
  componentId: "sc-1pl3hac-1"
})(["", ";"], formLabel);
var PhoneInputDescription = styled.div.withConfig({
  displayName: "PhoneInputDescription",
  componentId: "sc-1pl3hac-2"
})(["", ";", ";color:", ";"], fontSize('small'), fontWeight('normal'), themeGet('colors.gray.700'));
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1pl3hac-3"
})(["display:flex;"]);
var SelectContainer = styled.div.withConfig({
  displayName: "SelectContainer",
  componentId: "sc-1pl3hac-4"
})(["", ";flex:0 0 20%;min-width:", ";"], marginRight(2), unit(25));
var InputContainer = styled.div.withConfig({
  displayName: "InputContainer",
  componentId: "sc-1pl3hac-5"
})(["flex:1 1 80%;"]);

export { Container, InputContainer, PhoneInputContainer, PhoneInputDescription, PhoneInputLabel, SelectContainer };
